import { Link } from 'react-router-dom';
import { siteConfig, navLinks, categories } from '@/mocks/navigation';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="container-custom py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-base font-bold text-foreground-950 mb-4">{siteConfig.name}</h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {siteConfig.description}
            </p>
          </div>

          <div>
            <h4 className="text-base font-bold text-foreground-950 mb-4">快速导航</h4>
            <ul className="space-y-2">
              {navLinks.slice(0, 4).map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold text-foreground-950 mb-4">网址分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold text-foreground-950 mb-4">联系我们</h4>
            <ul className="space-y-2">
              <li className="text-sm text-foreground-600">
                <span className="text-foreground-400">邮箱：</span>admin@caoliu-dh.com
              </li>
              <li className="text-sm text-foreground-600">
                <span className="text-foreground-400">微信：</span>caoliu_nav
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-primary-600 hover:text-primary-700 transition-colors duration-200"
                >
                  了解更多 &rarr;
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} {siteConfig.name}. 版权所有。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <Link to="/about" className="hover:text-primary-600 transition-colors duration-200">
              关于我们
            </Link>
            <span>|</span>
            <Link to="/category/tutorials" className="hover:text-primary-600 transition-colors duration-200">
              访问教程
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}